// English source-of-truth translations.
// Keys are grouped by feature: ui, home, learn, continents, coloring, games,
// quiz, parents, daily, lang, globe, puzzles, microcopy.

const en = {
  ui: {
    brand: "My World Quest",
    brand_subtitle: "Color & Learn",
    explorerDay: "Explorer Day",
      nav: {
      home: "Today", countries: "Atlas", globe: "Explore",
      color: "Color", puzzles: "Puzzles", games: "Play", math: "Geo Maths",
      trip: "Trip", advanced: "Advanced", stickers: "Stickers", passport: "Me", campaigns: "Campaigns",
      quiz: "Quiz", parents: "Parents", more: "More", ask: "Ask the Globe ✨", "dream-trip": "Dream Trip", "geo-lines": "Latitude & Longitude", "maths-academy": "Maths Academy", knowledge: "Themed Adventures",
      "learn-topics": "Learn",
      countries: "Around the World",
      advanced: "Advanced Challenges",
      "hub-learn": "Learn", "hub-create": "Create", "hub-play": "Play", "hub-discover": "Discover",
    },
    accessibility: { bigText: "Big Text", highContrast: "High Contrast" },
    navGroups: {
      quick: "Quick",
      explore: "Explore",
      play: "Play & Learn",
      collect: "Collect",
      adv: "Adventure",
      grownup: "For Grown-ups",
    },
    actions: { back: "Back", close: "Close", reset: "Reset", save: "Save", retry: "Try Again", playAgain: "Play Again" },
  },
  microcopy: {
    great: "Great job! ⭐",
    correct: "✅ Correct!",
    nope: "Try again!",
    tryAgain: "Not quite. Keep going!",
    awesome: "Awesome!",
    welcome: "Welcome to {{country}}! Let's learn {{language}}.",
    allPlaced: "All placed! 🎉",
    youDidIt: "You did it!",
    perfect: "PERFECT!",
  },
  home: {
    streak: "Streak: {{n}} day",
    streak_plural: "Streak: {{n}} days",
    tagline: "From Screen Time to Discovery Time",
    title1: "Explore the World",
    title2: "One Country at a Time",
    subtitle: "Play fun geography adventures, quizzes and challenges — discover countries, cultures, flags, landmarks and more.",
    subtitleShort: "Explore the world — one lesson at a time.",
    playNow: "Start Exploring →",
    takeQuiz: "Take a Quiz",
    countryOfTheDay: "🌟 Country of the Day",
    discover: "Discover {{name}}!",
    letsGo: "Let's Go",
    whatNext: "What do you want to do today?",
    whatNextSub: "Pick anything — it's all fun!",
    tiles: {
      learn: "Learn Countries", learnDesc: "30+ countries with flags!",
      globe: "3D Globe", globeDesc: "Spin and tap to explore",
      passport: "📒 My Passport", passportDesc: "Stamps, level, world %",
      continents: "Continents", continentsDesc: "Explore all 7 continents",
      color: "Color Landmarks", colorDesc: "Color the Eiffel Tower!",
      puzzles: "Puzzles", puzzlesDesc: "Sliding & map puzzles",
      games: "Play Games", gamesDesc: "Match & Memory!",
      math: "Maths Geography", mathDesc: "Add km, count countries, compare sizes!",
      trip: "World Trip", tripDesc: "Plan a flight, measure km!",
      advanced: "Advanced Mode 🎓", advancedDesc: "Tough games for Pioneers, ages 11–15",
      stickers: "Sticker Album 📔", stickersDesc: "Collect a sticker from every game!",
      quiz: "Quiz Time", quizDesc: "Basic & advanced quiz",
      parents: "For Parents", parentsDesc: "See your child's progress",
    },
    openGlobe: "Open the Big Globe →",
    globeHint: "Tap a glowing pin to learn a country!",
    popularCountries: "Or tap a flag to explore",
    stats: { stars: "Stars", countries: "Countries", badges: "Badges", streak: "Streak" },
  },
  recommend: {
    aria: "Recommend My World Quest",
    eyebrow: "Loved playing?",
    title: "Tell a friend about My World Quest",
    subtitle: "Help another family discover safe, ad-free geography fun. Share the link in one tap.",
    copy: "Copy link",
    copied: "Link copied — share it with a friend!",
    copiedShort: "Copied!",
    copyFail: "Copy failed — long-press the link to copy it.",
    shareLabel: "Safe geography games for kids 5+",
    footnote: "Free · No ads · No accounts · Works offline",
  },
  trust: {
    aria: "Kid-safety promises",
    noAds: "No ads. Ever.",
    noIap: "No mid-game purchases.",
    noChat: "No chat, no strangers.",
    anyDevice: "Works on any device.",
  },
  lens: {
    kicker: "Explore by",
    subtitle: "Pick a way to explore",
    animals: "Animals",
    places: "Places",
    inventions: "Inventions",
    cultures: "Cultures",
    food: "Food",
    maps_and_worlds: "Maps & Worlds",
  },
  passport: {
    stampsTitle: "Stamp collection",
    stampsSub: "One stamp per fully-mastered quest.",
    stampsEmpty: "No stamps yet — finish your first Mastery Trial with 3 stars!",
    stampsCount: "{{n}} stamps",
    stampsCount_one: "{{n}} stamp",
  },
  daily: {
    label: "Daily Challenge",
    streakLabel: "Streak {{n}}",
    todayDone: "Today's done!",
    threeQuick: "3 quick questions",
    descUnlocked: "Solve 3 questions for 3 ⭐ + streak bonus (up to +5 ⭐).",
    descDone: "You scored {{score}}. Come back tomorrow for +1 ⭐ bonus!",
    start: "Start →",
    done: "Done",
    finished: "Daily Done!",
    score: "Score:",
    streakSuffix: "day",
    streakSuffix_plural: "days",
    bonus: "(+{{n}} bonus!)",
  },
  learn: {
    title: "Learn Countries 🌍",
    subtitle: "Click on any country card to learn about it. Tap the speaker to hear it out loud!",
    searchPlaceholder: "Search country, capital, or landmark…",
    clear: "Clear",
    filterAll: "All",
    hello: "Hello",
    capital: "Capital", language: "Language",
    learnedBtn: "I learned it! ⭐",
    learnLang: "Learn lang",
    noResults: "No countries found. Try another search!",
    // Homepage "Today's Learning Goals" strip + curriculum topic titles.
    goalsEyebrow: "Today's Learning Goals",
    goalsHeading: "🎯 Focus on these first",
    goalsSubtitle: "The four most-important things to master at ages {{tier}} — curriculum-picked.",
    goalsAllTopics: "See all topics",
    goalsLearnNow: "Learn now",
    goalsKey: "Key #{{n}}",
    topicTitles: {
      "art-design": "Drawing, Painting & Design",
      "music": "Music: Rhythm, Song & Notation",
      "computing-code": "Coding, Algorithms & E-Safety",
      "physical-education": "PE, Health & Fitness",
      "world-religions": "World Religions & Beliefs",
      "wellbeing-relationships": "Health, Feelings & Friendships",
    },
  },
  continents: {
    title: "Continent Maps 🗺️",
    subtitle: "Tap a continent to discover its countries and fun facts!",
    countriesIn: "Countries in {{name}}:",
    learnMore: "Learn more countries →",
  },
  coloring: {
    title: "Color Landmarks 🎨",
    subtitle: "{{n}} landmarks to color. Or download printable worksheets!",
    printOne: "Print this one",
    printAll: "Download all PDF",
    tools: "Tools",
    colors: "Colors",
    fill: "Fill", pencil: "Pencil", erase: "Erase",
    undo: "Undo", redo: "Redo",
    sub: "Tap a tile next to the empty space to slide it. Rebuild the {{name}}!",
  },
  games: {
    title: "Match the Country! 🎮",
    subtitle: "Drag (or tap) a country flag to its continent.",
    newGame: "🔄 New Game",
    dragFlags: "Drag these flags 👇",
  },
  quiz: {
    title: "Quiz Time! 🧠",
    subtitle: "Pick a level. You can do it!",
    basic: "Basic Quiz",
    advanced: "Advanced Quiz",
    basicDesc: "5 easy questions about countries and continents.",
    advancedDesc: "10 tricky questions. Are you ready?",
    upTo: "Up to {{n}} ⭐",
    question: "Question {{i}} / {{n}}",
    backToMenu: "Back to Menu",
    perfect: "PERFECT!",
    greatJob: "Great Job!",
    youGot: "You got",
    outOf: "out of",
  },
  parents: {
    title: "Progress Dashboard 👨‍👩‍👧",
    subtitle: "Track your child's learning journey.",
    parentsOnly: "Parents Only",
    mathPrompt: "Answer this question to enter.",
    unlock: "Unlock",
    wrong: "Hmm, try again!",
    resetProgress: "Reset Progress",
    resetConfirm: "Reset all progress? This can't be undone.",
    badges: "Badges",
    recentActivity: "Recent Activity",
    noActivity: "No activity yet. Time to explore!",
    notYet: "Not yet",
    certTitle: "Certificate of Exploration!",
    certBody: "Your child has earned {{stars}} stars and explored {{countries}} countries.",
    printCert: "🖨️ Print Certificate",
    statsLabels: {
      stars: "Stars Earned", streak: "Day Streak", countries: "Countries Learned",
      quizzes: "Quizzes Done", games: "Games Won", coloring: "Coloring Pages",
    },
  },
  lang: {
    title: "Learn {{language}}",
    sub: "From {{country}}! Tap any phrase to hear it.",
    welcome: "Welcome",
    finish: "I'm Done! ⭐⭐",
    awesome: "Awesome practicing!",
    finishSub: "Finish the lesson to earn 2 stars.",
    tapToHear: "Tap to hear",
    speakTitle: "🎙️ Speak the Word",
    speakSubtitle: "Tap the mic and say each phrase out loud!",
    speakUnsupported: "Voice mode needs Chrome, Edge or Safari iOS 14+.",
    listening: "Listening…",
    tapMic: "Tap mic and say:",
    wellDone: "Well done!",
    tryItAgain: "Try saying it again",
    youSaid: "You said:",
    expected: "Expected:",
    phrases: {
      Hello: "Hello", "Thank you": "Thank you", Goodbye: "Goodbye",
      Yes: "Yes", No: "No", One: "One", Two: "Two", Three: "Three",
    },
  },
  globe: {
    title: "3D Globe 🌐",
    subtitle: "Spin the world. Glowing pins are countries to discover. Gold pins are countries you've learned!",
    learnedCounter: "{{n}} / {{total}} learned",
    spinTap: "Spin & Tap!",
    spinTapSub: "Click any glowing pin on the globe to discover a country.",
    learnedTag: "⭐ Learned",
    moreInfo: "More Info →",
    learnLang: "🗣️ Learn Language",
  },
  puzzles: {
    title: "Puzzles 🧩",
    subtitle: "Pick a puzzle type and play!",
    sliding: "🖼️ Landmark Sliding Puzzle",
    shape: "🗺️ Map Shape Puzzle",
    placed: "{{done}} / {{total}} placed",
    tapPrompt: "Tap a flag, then tap the right spot.",
    tapNext: "Now tap the right spot →",
    moves: "Moves: {{n}}",
    best: "Best: {{n}}",
    shuffle: "Shuffle",
    solvedIn: "🎉 You solved it in {{n}} moves!",
    newBest: "🏁 NEW BEST in {{n}} moves!",
    record: "Your record: {{n}} moves",
  },
  certificate: {
    title: "🎉 Globe Trotter!",
    body: "Whoa! You've learned {{n}} countries. You're an official Globe Trotter!",
    print: "🖨️ Print my Certificate",
    keep: "Keep Exploring",
    share: "Share with a friend",
    shareSubtitle: "I just earned my Globe Trotter badge!",
  },
  langSwitcher: {
    label: "Language",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية", urdu: "اردو",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  math: {
    title: "Maths Geography 🧮",
    subtitle: "Add kilometers, count countries, and compare sizes!",
    pick: "Pick a game:",
    games: {
      km: { name: "Kilometer Adder", desc: "Add distances between cities", emoji: "🛣️" },
      count: { name: "Count the Countries", desc: "Count countries on a continent", emoji: "🔢" },
      bigger: { name: "Bigger or Smaller?", desc: "Compare country sizes", emoji: "📏" },
    },
    score: "Score: {{n}}",
    next: "Next →",
    correct: "✅ Right! +{{n}} ⭐",
    wrong: "Try again! The answer was {{a}}.",
    yourAnswer: "Your answer:",
    submit: "Check",
    finish: "All done! 🎉",
    playAgain: "Play Again",
    km: {
      prompt: "How many km in total?",
      hop1: "{{from}} → {{to}}",
      hopJoin: "then",
    },
    count: {
      prompt: "How many of these countries are in {{continent}}?",
    },
    bigger: {
      prompt: "Which country is BIGGER?",
      promptSmaller: "Which country is SMALLER?",
    },
    back: "← Back to Math games",
  },
  common: {
    whereToNext: "Where to next?",
    home: "Home",
    earnMoreStars: "⭐ Earn More Stars",
    earnHowTo: "Play a quick game — each one adds XP to your level!",
    pickAge: "Pick age",
    ages: "Ages",
    startExploring: "Start Exploring",
    pickAnywhere: "Pick anywhere above — or hit go!",
    tapAnyCountry: "Tap any country to learn its story!",
    exploreGlobe: "Explore the Globe",
    exploreGlobeSub: "Full-screen 3D adventure",
  },
  shortcuts: {
    home: "Home",
    continents: "Continents",
    globe: "Globe",
    ask: "Ask",
    landmarks: "Landmarks",
    flags: "Flags",
    pixel: "Pixel",
    puzzles: "Puzzles",
    math: "Math",
    trip: "Trip",
    quiz: "Quiz",
    quests: "Quests",
    stickers: "Stickers",
    miniGames: "Mini Games",
    geoMath: "Geo Math",
    quickQuiz: "Quick Quiz",
    myTrophies: "My Trophies",
    colorCreate: "Color & Create",
    spinGlobe: "Spin the Globe",
    askGlobe: "Ask the Globe",
    dreamTrip: "Dream Trip",
    earnStars: "Earn Stars",
    tryAQuest: "Try a Quest",
    playAgain: "Play Again",
    learnCountry: "Learn a Country",
    colorLandmark: "Color a Landmark",
    learnCountries: "Learn Countries",
    // Additional shortcut labels used by page-curated NextStops lists.
    // Previously undefined → rendered as raw "shortcuts.parents" etc.
    parents:   "Parents & Teachers",
    safety:    "Safety",
    blog:      "Blog",
    explore:   "Explore",
    advanced:  "Advanced",
    advancedHub: "Advanced Hub",
    history:   "My History",
    passport:  "My Passport",
    squishyHop: "Squishy Hop",
    mathSnap:  "Math Snap",
    spellCountry: "Spell a Country",
    geoLines:  "Latitude & Longitude",
    advanced: "Advanced Hub",
    advancedHub: "Advanced Hub",
    geoLines: "World Lines",
    squishyHop: "Squishy Hop",
    mathSnap: "Math Snap",
    spellCountry: "Spell the Country",
    language: "Language",
  },
  coloringExtra: {
    modeLandmarks: "Landmarks",
    modeFlags: "Flag Artist",
    modePixel: "Pixel Art",
    modeMandala: "Mandala",
    diffEasy: "Easy",
    diffMedium: "Medium",
    diffExpert: "Expert",
    difficultyLabel: "Difficulty:",
  },
  tilesExtra: {
    labelLearn: "Learn",
    labelCreate: "Create",
    labelPlay: "Play",
    labelTrophies: "Discover",
    subLearn: "Countries, Knowledge, Maths",
    subCreate: "Color, Flags, Stickers",
    subPlay: "Games, Quizzes, Puzzles",
    subDiscover: "Passport, Quests, Tools",
    whatNextSub: "Pick anything — it's all fun!",
  },
  pills: {
    orTry: "Or try ↓",
    squishyHop: "Squishy Hop",
    mathSnap: "Math Snap",
    spellCountry: "Spell a country",
    colorLandmark: "Color a landmark",
    flagArtist: "Flag artist",
    pixelArt: "Pixel art",
    solvePuzzle: "Solve a puzzle",
    dreamTrip: "Plan a dream trip",
    geoMath: "Try geo math",
    continentQuests: "Continent quests",
    stickerBook: "Sticker book",
    famousPeople: "Meet famous people",
    culturalSpot: "Cultural spotlight",
    quickQuiz: "Quick quiz",
    continentMaps: "Continent maps",
    spinGlobe: "Spin the globe",
    askGlobe: "Ask the globe",
    myTrophies: "My trophies",
    advancedHub: "Advanced hub",
    geoLines: "World lines",
  },
  canvas: {
    tools: "Tools",
    brushSize: "Brush Size",
    colors: "Colors",
    patterns: "Patterns",
    modes: "Modes",
    solid: "Solid",
    anyColor: "Any color",
    recent: "Recent",
    sticker: "Sticker",
    symmetry: "Symmetry",
    colorByNumber: "Color-by-number",
    reference: "Reference",
    undo: "Undo",
    redo: "Redo",
    reset: "Reset",
    replay: "Replay",
    check: "Check",
    save: "Save",
    fill: "Fill",
    pencil: "Pencil",
    stamp: "Stamp",
    erase: "Erase",
    on: "ON",
    off: "OFF",
    tool: "Tool:",
    pattern: "pattern:",
    printOne: "Print this one",
    downloadAll: "Download all",
    appTitle: "Color & Create 🎨",
    appSub: "Brushes, patterns, stickers, color-by-number & more!",
  },
};

export default en;
